var _excluded = ["basename"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CopyToClipboard } from '../CopyToClipboard';
import { P } from '../../elements';
import { useCopySuccess, useShareUrl } from './hooks';
import Icon from './Icon';
export var Box = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border: var(--sharebox-border);\n  background-color: #fff;\n  overflow-x: hidden;\n  cursor: pointer;\n  max-width: calc(100vw - (var(--sharebox-gutter-x) * 2));\n"])));
export var Button = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  border: none;\n  background: transparent;\n  outline: none;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-left: var(--sharebox-border);\n  width: 32px;\n  height: 100%;\n\n  svg {\n    pointer-events: none;\n  }\n"])));
var Text = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  overflow: scroll;\n  flex: 1 0;\n  white-space: nowrap;\n  font-weight: 500;\n"])));
var CopySuccess = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  left: 50%;\n  top: 80px;\n  padding: 5px 10px;\n  transform: translateX(-50%);\n  border: 1px solid var(--night);\n  font-weight: 500;\n  border-radius: 15px;\n  background-color: #fff;\n  font-size: 1rem;\n  font-family: var(--font-family-primary);\n\n  @media (min-width: 768px) {\n    top: calc(var(--header-height) + 20px);\n  }\n"])));

function ShareBlock(_ref) {
  var basename = _ref.basename,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useCopySuccess = useCopySuccess(),
      onCopy = _useCopySuccess.onCopy,
      showSuccess = _useCopySuccess.showSuccess;

  var shareUrl = useShareUrl(basename);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(P, {
    className: "fw-bold mb-2"
  }, "Share"), /*#__PURE__*/React.createElement(Box, {
    title: "Share"
  }, /*#__PURE__*/React.createElement(Text, null, shareUrl), /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: shareUrl,
    onSuccess: onCopy
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, null)))), showSuccess && /*#__PURE__*/React.createElement(CopySuccess, null, "Copied to Clipboard"));
}

ShareBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  basename: PropTypes.string.isRequired
} : {};
export default ShareBlock;